/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResumeDto } from '../models/ResumeDto';
import type { UpdateResumeDataDto } from '../models/UpdateResumeDataDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ResumesService {
  /**
   * 현재 유저의 이력서 가져오기
   * @returns ResumeDto
   * @throws ApiError
   */
  public static resumeControllerResume(): CancelablePromise<ResumeDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/resumes/me',
    });
  }

  /**
   * 이력서 수정
   * @returns ResumeDto
   * @throws ApiError
   */
  public static resumeControllerUpdateResume({
    requestBody,
  }: {
    requestBody: UpdateResumeDataDto;
  }): CancelablePromise<ResumeDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/resumes/me',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
